import React from 'react';
import { useNavigate } from 'react-router-dom';
import PublicLayout from '../components/PublicLayout';
import { Award, Users, Calendar, BookOpen, TrendingUp, MessageSquare, Shield, Zap } from 'lucide-react';

const FeaturesPage = () => {
  const navigate = useNavigate();

  const features = [
    {
      icon: Users,
      title: "Exclusive Network",
      description: "Connect with elite entrepreneurs, investors, and business leaders in your industry."
    },
    {
      icon: Calendar,
      title: "Premium Events",
      description: "Attend exclusive networking events, workshops, and conferences hosted by industry leaders."
    },
    {
      icon: Award,
      title: "Challenges & Rewards",
      description: "Participate in community challenges, earn points, and climb the leaderboard."
    },
    {
      icon: BookOpen,
      title: "Digital Magazine",
      description: "Access our monthly digital magazine featuring industry insights and member spotlights."
    },
    {
      icon: TrendingUp,
      title: "Social Media Boosts",
      description: "Support fellow members and earn points by boosting their social media presence."
    },
    {
      icon: MessageSquare,
      title: "Community Chat",
      description: "Direct messaging system to connect with members, hosts, and mentors."
    },
    {
      icon: Shield,
      title: "Verified Members",
      description: "All members are verified, ensuring a trusted and professional network."
    },
    {
      icon: Zap,
      title: "Revenue Opportunities",
      description: "Hosts can monetize their communities through events, challenges, and exclusive content."
    }
  ];

  return (
    <PublicLayout>
      <div className="public-page">
        {/* Hero Section */}
        <div className="public-page-header">
          <h1>Platform Features</h1>
          <p>
            Everything you need to grow your network and achieve extraordinary success.
          </p>
        </div>

        <div className="public-page-content">
          {/* Features Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
            {features.map((feature, index) => {
              const Icon = feature.icon;
              return (
                <div key={index} className="feature-card">
                  <div className="feature-icon" style={{background: 'var(--gold)', marginBottom: '1.5rem'}}>
                    <Icon className="w-7 h-7" style={{color: 'var(--ink)'}} />
                  </div>
                  <h3 style={{fontFamily: 'var(--font-heading)', fontSize: '1.5rem', marginBottom: '1rem'}}>{feature.title}</h3>
                  <p style={{color: 'var(--muted)'}}>{feature.description}</p>
                </div>
              );
            })}
          </div>

          {/* CTA Section */}
          <div className="text-center rounded-2xl p-12" style={{background: 'linear-gradient(135deg, #D4AF37 0%, #C29A4B 100%)', color: '#fff'}}>
            <h2 className="mb-4" style={{color: '#fff', fontFamily: 'var(--font-heading)', fontSize: '3rem'}}>Ready to Experience These Features?</h2>
            <p className="text-xl mb-8 max-w-2xl mx-auto" style={{color: 'rgba(255,255,255,0.9)'}}>
              Join Success Club today and unlock access to our complete platform.
            </p>
            <button 
              onClick={() => navigate('/auth')}
              className="bg-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-gray-100 transition-colors"
              style={{color: '#1A1A1A'}}
            >
              Get Started Now
            </button>
          </div>
        </div>
      </div>
    </PublicLayout>
  );
};

export default FeaturesPage;